/* Imports */
import React from "react"
import { v4 as uuid } from "uuid"
import styled from "styled-components"
import { Font, Cover, Image, Flexbox, Button, Wrapper, Main, Section, Grid, Variables } from "fajny-react"

import BaseLayout from "../components/BaseLayout"
import CodeContainer from "../components/CodeContainer"
import CardHome from "../components/CardHome"

import siteData from "../data/site-data"

const Title = styled(Font.H1)`
    @media ${Variables.Breakpoints.Mobile} {
        font-size: 3rem;
    }
`

const Homepage = () => {
    const cards = [
        {
            img: "logo-react",
            altImg: "Logo React",
            title: "Built with React",
            text: "This Framework is entirely built in React and TSX, to ease the development!",
            textBtn: "Learn more about SCSS",
            toBtn: "https://reactjs.org/",
            blank: true,
        },
        {
            img: "figma-logo",
            altImg: "Logo Figma",
            title: "Copy Figma file",
            text: "You can also use Fajny CSS in your mockups, just download the Figma file and use it as library!",
            textBtn: "Download file",
            toBtn: siteData.figma,
            blank: true,
        },
        {
            img: "sass-logo",
            altImg: "Logo Sass",
            title: "SCSS version",
            text: "If you want to use Fajny inside a non React project, you can use the SCSS version!",
            textBtn: "Visit Fajny CSS",
            toBtn: siteData.urlFajnyHtml,
            blank: true,
        },
        {
            img: "logo-free-license",
            altImg: "Logo free license",
            title: "Totally Free",
            text: "You can use everything for free, without having to credit us!",
            textBtn: "Start using Fajny CSS",
            toBtn: "/getting-started",
        },
    ]

    return (
        <BaseLayout title="Homepage">
            <Cover
                src="/images/cover-parallax.jpg"
                alt="Cover Fajny CSS"
                overlay
            >
                <Image
                    src="/images/logo-fajny-css-white.svg"
                    alt="Logo Fajny CSS"
                    width="40%"
                />

                <Title display>
                    The last SCSS Framework you will ever need!
                </Title>

                <Flexbox align="center" justify="center" gap="s">
                    <Button
                        href={siteData.urlNpm}
                        color="white"
                        fajnyIconLeft="npm-brand"
                        target="_blank"
                        rel="noreferrer noopener"
                        as="a"
                    >
                        Check on npm
                    </Button>

                    <Button
                        href={siteData.github}
                        color="white"
                        buttonStyle="outline"
                        fajnyIconLeft="github-brand"
                        target="_blank"
                        rel="noreferrer noopener"
                        as="a"
                    >
                        Check on GitHub
                    </Button>
                </Flexbox>
            </Cover>

            <Wrapper>
                <Main size="large">
                    <Section gap="small">
                        <Font.H2>Install Fajny in your project</Font.H2>

                        <CodeContainer language="shell">
                            {siteData.npmReact}
                        </CodeContainer>

                        <Font.P>
                            Then, open your <code>index.js</code> file and add:
                        </Font.P>

                        <CodeContainer>
                            {siteData.cssReact}
                        </CodeContainer>
                    </Section>

                    <Section gap="small">
                        <Font.H2>Why choosing Fajny CSS</Font.H2>

                        <Grid col={2} gap="m">
                            {cards.map(card => (
                                <CardHome card={card} key={uuid()} />
                            ))}
                        </Grid>
                    </Section>
                </Main>
            </Wrapper>
        </BaseLayout>
    )
}

export default Homepage
